(() => {
  if (window.snapcaseMegaMenuModelImagesReady) return;
  window.snapcaseMegaMenuModelImagesReady = true;

  const showModel = (modelLink) => {
    const layout = modelLink.closest('.mega-menu__layout');
    if (!layout) return;

    const spotlight = layout.querySelector('[data-model-spotlight]');
    const image = spotlight && spotlight.querySelector('.mega-menu__spotlight-image');
    const title = spotlight && spotlight.querySelector('.mega-menu__spotlight-title');
    if (!spotlight || !image || !title || !modelLink.dataset.modelImage) return;

    const requestId = (layout.modelImageRequestId || 0) + 1;
    layout.modelImageRequestId = requestId;
    const nextImage = new Image();
    nextImage.onload = () => {
      if (layout.modelImageRequestId !== requestId) return;
      image.src = nextImage.src;
      image.alt = modelLink.textContent.trim();
      image.dataset.device = modelLink.dataset.modelDevice;
      image.dataset.fit = modelLink.dataset.modelFit;
      title.textContent = modelLink.textContent.trim();
      spotlight.href = modelLink.href;
    };
    nextImage.src = modelLink.dataset.modelImage;
  };

  document.addEventListener('pointerover', (event) => {
    const modelLink = event.target.closest && event.target.closest('[data-model-image]');
    if (!modelLink || modelLink.contains(event.relatedTarget)) return;
    showModel(modelLink);
  });

  document.addEventListener('focusin', (event) => {
    const modelLink = event.target.closest && event.target.closest('[data-model-image]');
    if (modelLink) showModel(modelLink);
  });
})();
